import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['PlausibilityCheckResult'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getPlausibilityCheckResultById: build.query<
        GetPlausibilityCheckResultByIdApiResponse,
        GetPlausibilityCheckResultByIdApiArg
      >({
        query: (queryArg) => ({ url: `/PlausibilityCheckResult/${queryArg}` }),
        providesTags: ['PlausibilityCheckResult'],
      }),
      getPlausibilityCheckResultGetAll: build.query<
        GetPlausibilityCheckResultGetAllApiResponse,
        GetPlausibilityCheckResultGetAllApiArg
      >({
        query: () => ({ url: `/PlausibilityCheckResult/get-all` }),
        providesTags: ['PlausibilityCheckResult'],
      }),
      getPlausibilityCheckResultGetAllByImportOperation: build.query<
        GetPlausibilityCheckResultGetAllByImportOperationApiResponse,
        GetPlausibilityCheckResultGetAllByImportOperationApiArg
      >({
        query: (queryArg) => ({
          url: `/PlausibilityCheckResult/get-all-by-import-operation`,
          params: {
            importOperationId: queryArg,
          },
        }),
        providesTags: ['PlausibilityCheckResult'],
      }),
      putPlausibilityCheckResultUpdateStatus: build.query<
        PutPlausibilityCheckResultUpdateStatusApiResponse,
        PutPlausibilityCheckResultUpdateStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/PlausibilityCheckResult/update-status`,
          method: 'PUT',
          params: {
            plausibilityCheckResultId: queryArg.plausibilityCheckResultId,
            isPlausible: queryArg.isPlausible,
          },
        }),
        providesTags: ['PlausibilityCheckResult'],
      }),
      putPlausibilityCheckResultUpdateComment: build.query<
        PutPlausibilityCheckResultUpdateCommentApiResponse,
        PutPlausibilityCheckResultUpdateCommentApiArg
      >({
        query: (queryArg) => ({
          url: `/PlausibilityCheckResult/update-Comment`,
          method: 'PUT',
          params: {
            plausibilityCheckResultId: queryArg.plausibilityCheckResultId,
            newComment: queryArg.newComment,
          },
        }),
        providesTags: ['PlausibilityCheckResult'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as plausibilityCheckResultApi };
export type GetPlausibilityCheckResultByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoPlausibilityCheckResultExternalDto;
export type GetPlausibilityCheckResultByIdApiArg = number;
export type GetPlausibilityCheckResultGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoPlausibilityCheckResultExternalDto;
export type GetPlausibilityCheckResultGetAllApiArg = void;
export type GetPlausibilityCheckResultGetAllByImportOperationApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoPlausibilityCheckResultExternalDto;
export type GetPlausibilityCheckResultGetAllByImportOperationApiArg =
  /** The import operation for which the PlausibilityCheckResults will be retrieved */ number | undefined;
export type PutPlausibilityCheckResultUpdateStatusApiResponse = unknown;
export type PutPlausibilityCheckResultUpdateStatusApiArg = {
  /** Id for which the status is updated */
  plausibilityCheckResultId?: number;
  /** The new status */
  isPlausible?: boolean;
};
export type PutPlausibilityCheckResultUpdateCommentApiResponse = unknown;
export type PutPlausibilityCheckResultUpdateCommentApiArg = {
  /** Id for which the status is updated */
  plausibilityCheckResultId?: number;
  /** The new comment */
  newComment?: string;
};
export type ApiCommonExternalDtoPlausibilityCheckResultExternalDto = {
  id?: number;
  tsoId?: number;
  isPlausible: boolean;
  start: string;
  end: string;
  rule: string;
  comment: string;
  importOperationId: number;
  measurementDeviceId: number;
  measurementParameterId: number;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoPlausibilityCheckResultExternalDto = {
  externalDto?: ApiCommonExternalDtoPlausibilityCheckResultExternalDto;
  externalDtos?: ApiCommonExternalDtoPlausibilityCheckResultExternalDto[] | null;
};
export const {
  useGetPlausibilityCheckResultByIdQuery,
  useLazyGetPlausibilityCheckResultByIdQuery,
  useGetPlausibilityCheckResultGetAllQuery,
  useLazyGetPlausibilityCheckResultGetAllQuery,
  useGetPlausibilityCheckResultGetAllByImportOperationQuery,
  useLazyGetPlausibilityCheckResultGetAllByImportOperationQuery,
  usePutPlausibilityCheckResultUpdateStatusQuery,
  useLazyPutPlausibilityCheckResultUpdateStatusQuery,
  usePutPlausibilityCheckResultUpdateCommentQuery,
  useLazyPutPlausibilityCheckResultUpdateCommentQuery,
} = injectedRtkApi;
